import {customElement, property} from 'lit/decorators.js';
import {css, CSSResult, html, LitElement, unsafeCSS} from 'lit';
import {Events, ProductIdentifierContainer} from '../../../@types/wishlist.js';
import '../event-layer-content/event-layer-content.js';
import baseLayerStyles from '../base-layer/base-layer.scss?inline';
import styles from './event-web-layer.scss?inline';

@customElement('ents-event-web-layer')
export class EventWebLayer extends LitElement {
  @property({type: Boolean, attribute: 'logged-in'})
  private loggedIn: boolean = false;

  @property({type: Boolean, attribute: 'show-layer', reflect: true})
  private showLayer: boolean = false;

  @property({type: Object, reflect: false})
  private events: Events = {unseenProductEvents: [], seenProductEvents: []};

  static get styles(): CSSResult[] {
    return [css`${unsafeCSS(styles)}`, css`${unsafeCSS(baseLayerStyles)}`];
  }

  private handleLayerClosed = () => {
    if (this.showLayer) {
      this.showLayer = false;
    }
    this.dispatchEvent(new Event('ents-event-layer-close', {composed: true, bubbles: true}));
  };

  private handleEventItemClicked = (e: CustomEvent<ProductIdentifierContainer>) => {
    document.dispatchEvent(new CustomEvent('ents:wishlist-scroll-to-product', {
      detail: {identifier: e.detail.identifier},
      bubbles: true,
      composed: true
    }));
    this.handleLayerClosed();
  };

  private renderContent() {
    return html`
      <div class="ents-event-web-layer" data-test-ents-event-layer>
        <ents-event-layer-content
          ?logged-in="${this.loggedIn}"
          ?shown="${this.showLayer}"
          .events="${this.events}"
          @ents-wishlist-event-item-clicked="${this.handleEventItemClicked}"
        ></ents-event-layer-content>
      </div>`;
  }

  render() {
    return html`
      <ents-base-layer
        drawer-test-id="ents-wishlist-event-layer"
        ?showLayer="${this.showLayer}"
        @ents-layer-closed="${this.handleLayerClosed}"
      >
        ${this.renderContent()}
      </ents-base-layer>`;
  }
}
